export const i18n = {
  "messages": {
    "nl-NL": {
      "omt": {
        "gui": {
          "orders": {
            "search": {
              "filters": {
                "label": {
                  "title": "Filters",
                  "order-no": "Order nr",
                  "fulfilment-method": "Afleverwijze",
                  "dispatch-type": "Type levering",
                  "location-type": "Type levering",
                  "shipment-status": "Status",
                  "block-status": "Blokkeerstatus",
                  "sales-formula": "Sales formule",
                  "sales-channel": "Sales channel",
                  "met-crediteringen": "Met crediteringen",
                  "carrier-method": "Vervoersmethode",
                  "payment-method": "Betaalmethode",
                  "placed-on-before": "Geplaatst op of voor",
                  "placed-on-after": "Geplaatst op of vanaf",
                  "max-age-days": "Max. dagen oud",
                  "promised-delivery-date": "Beloofde afleverdatum",
                  "product-identifier": "Product nr",
                  "address-type": "Adrestype",
                  "name": "Naam",
                  "city": "Plaatsnaam",
                  "country": "Land",
                  "customer-number": "Klantnummer",
                  "email": "emailaddress",
                  "address-name": "Naam",
                  "has-comments": "Met opmerkingen",
                  "dispatcher-identifier": "Specifieke locatie",
                  "with-refunds": "Met crediteringen",
                  "dispatcher-type": "Type locatie",
                  "dispatch-request-status": "Leveringsstatus",
                  "dispatch-request-batch-type": "Batchtype",
                  "dispatch-request-batch-status": "Batchstatus",
                  "dispatch-request-batch-identifier": "Batch",
                  "responsible-store-identifier": "Verantwoordelijke winkel",
                },
                "placeholder": {
                  "product-identifier": "Bijv. 123456",
                  "name": "bijv. Jansen",
                  "city": "bijv. jan@smit.com"
                },
                "action": {
                  "hide-filters": "Verberg filters",
                  "reset-filters": "Filters resetten"
                }
              },
              "results": {
                "action": {
                  "edit-columns": "Bewerk kolommen",
                  "hide-columns": "Verberg kolommen"
                },
                "label": {
                  "no-results": "Geen resultaten"
                }
              }
            }
          }
        }
      }
    },
    "en-US": {
      "omt": {
        "gui": {
          "orders": {
            "search": {
              "filters": {
                "label": {
                  "title": "Filters",
                  "order-no": "Order no",
                  "fulfilment-method": "Delivery fulfilment method",
                  "dispatch-type": "Dispatch type",
                  "location-type": "Location type",
                  "shipment-status": "Status",
                  "block-status": "Block status",
                  "sales-formula": "Sales formula",
                  "sales-channel": "Sales channel",
                  "met-crediteringen": "With credits",
                  "carrier-method": "Carrier method",
                  "payment-method": "Payment method",
                  "placed-on-before": "Placed on or before",
                  "placed-on-after": "Placed on or after",
                  "max-age-days": "Max. age (days)",
                  "promised-delivery-date": "Promised delivery date",
                  "product-identifier": "Product no",
                  "address-type": "Address type",
                  "name": "Name",
                  "city": "City",
                  "country": "Country",
                  "customer-number": "Customer number",
                  "email": "e-mail address",
                  "address-name": "Name",
                  "has-comments": "With comments",
                  "dispatcher-identifier": "Specific location",
                  "with-refunds": "With refunds",
                  "dispatcher-type": "Location type",
                  "dispatch-request-status": "Delivery status",
                  "dispatch-request-batch-type": "Batch type",
                  "dispatch-request-batch-status": "Batch status",
                  "responsible-store-identifier": "Responsible store",
                },
                "placeholder": {
                  "product-identifier": "e.g. 123456",
                  "name": "e.g. Johnson",
                  "city": "e.g. john@smith.com"
                },
                "action": {
                  "hide-filters": "Hide filters",
                  "reset-filters": "Reset filters"
                }
              },
              "results": {
                "action": {
                  "edit-columns": "Edit columns",
                  "hide-columns": "Hide columns"
                },
                "label": {
                  "no-results": "No results"
                }
              }
            }
          }
        }
      }
    }
  }
};

export default i18n;
